"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWelcomeBonus = void 0;
var react_1 = require("react");
var useWelcomeBonus = function (promotions) {
    return (0, react_1.useMemo)(function () {
        if (!promotions) {
            return { maxBonus: 0, freespins: 0 };
        }
        return Object.values(promotions).reduce(function (acc, item) {
            return __assign(__assign({}, acc), { maxBonus: (item === null || item === void 0 ? void 0 : item.maxBonus)
                    ? Number(item.maxBonus) + ((acc === null || acc === void 0 ? void 0 : acc['maxBonus']) || 0)
                    : 0, freespins: 'freespins' in item
                    ? Number(item.freespins) + ((acc === null || acc === void 0 ? void 0 : acc['freespins']) || 0)
                    : (acc === null || acc === void 0 ? void 0 : acc['freespins']) || 0 });
        }, {});
    }, [promotions]);
};
exports.useWelcomeBonus = useWelcomeBonus;
